import React from "react";

const withInitialization = (store, initializerAction) => Component => {
  class WithInitialization extends React.Component {
    constructor(props) {
      super(props);

      store.dispatch(initializerAction(props));
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  return WithInitialization;
};

export default withInitialization;
